export default [
    {
        path: '/newsletters',
        name:'dashboard',
        component:()=> import('@/views/pages/cloudx/administration/Newsletters.vue')
    },
]
